export default {"src":"/_next/static/media/rating.03f103a0.svg","height":15,"width":72};